// extracted by mini-css-extract-plugin
module.exports = {"shadowStyle":"style_shadowStyle__nAGN0","buttonStyle":"style_buttonStyle__zqRvU"};